import React from 'react'
import { observer } from 'mobx-react-lite'

import { useStores } from '@trivie/core'
import { Leaderboard } from '@trivie/ui-mobile/components/leaderboard'

export const AlltimeLeaderboardTab = observer((props: any) => {
  const { selectedTag, load } = props
  const { leaderboardStore, rootCache } = useStores()
  const { loadingAllTime, allTimeUserLeaderboard, tagLeaderboard } = leaderboardStore

  const refresh = () => {
    rootCache.invalidateAction('getLeaderboards', leaderboardStore)
    rootCache.invalidateAction('getLeaderboardRank', leaderboardStore)
    load('all_time')
  }

  return (
    <Leaderboard
      refresh={refresh}
      data={
        selectedTag !== '' && selectedTag !== 'User'
          ? tagLeaderboard.filter((tag: any) => tag.rank != null)
          : allTimeUserLeaderboard
      }
      loading={loadingAllTime}
      selectedTag={selectedTag}
    />
  )
})
